import React, { useMemo, useRef } from 'react';
import { MenuItem, Link } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import StandardTooltip from '../StandardTooltip';
export default function ActionMenuItem(_ref) {
  let {
    action,
    dedicateSpaceForBlankIcon = false,
    data,
    onCloseMenu,
    disabled = false
  } = _ref;
  const linkRef = useRef();
  const handleClick = event => {
    if (typeof onCloseMenu === 'function') {
      onCloseMenu(event);
    }
    if (typeof action.onClick === 'function') {
      action.onClick(event, data);
    }
  };
  const handleLinkClick = event => {
    if (linkRef.current) {
      linkRef.current.click();
    } else {
      handleClick(event);
    }
  };
  const RenderContent = useMemo(() => {
    const TextSpan = /*#__PURE__*/React.createElement("span", null, action.label);
    const ItemIcon = /*#__PURE__*/React.createElement(ListItemIcon, null, action.icon);
    const ItemIconBlank = /*#__PURE__*/React.createElement(ListItemIcon, null, "\xA0");
    return /*#__PURE__*/React.createElement(React.Fragment, null, action.icon && ItemIcon, !action.icon && dedicateSpaceForBlankIcon == true && ItemIconBlank, /*#__PURE__*/React.createElement(ListItemText, null, TextSpan));
  }, [action]);
  return /*#__PURE__*/React.createElement(StandardTooltip, {
    title: action.tooltip,
    enterDelay: 1000,
    leaveDelay: 0
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleLinkClick,
    disabled: disabled || action.disabled
  }, action.href ? /*#__PURE__*/React.createElement(Link, {
    component: "a",
    ref: linkRef,
    href: action.href,
    onClick: handleClick,
    sx: {
      display: 'flex',
      textDecoration: "none",
      color: "inherit",
      "&:hover": {
        color: "inherit"
      }
    }
  }, RenderContent) : RenderContent));
}